var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.6,
    height: 23.95,
    viewBox: "0 0 23.6 23.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Download",
    "data-name": "Icon Download",
    transform: "translate(-160.999 -88.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5128",
    "data-name": "Path 5128",
    d: "M183.9,317.8a.7.7,0,0,0-.7.7v5.419a2.1,2.1,0,0,1-2.1,2.1H164.5a2.1,2.1,0,0,1-2.1-2.1V318.5a.7.7,0,0,0-1.4,0v5.419a3.5,3.5,0,0,0,3.5,3.5H181.1a3.5,3.5,0,0,0,3.5-3.5V318.5A.7.7,0,0,0,183.9,317.8Z",
    transform: "translate(0 -215.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M340.2,106.994a.7.7,0,1,1-1.4,0V88.9a.7.7,0,1,1,1.4,0Z",
    transform: "translate(-166.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5130",
    "data-name": "Path 5130",
    d: "M340,316.91a.7.7,0,1,1-1-.973l4.011-4.146a.7.7,0,1,1,1,.973Z",
    transform: "translate(-166.7 -209.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5131",
    "data-name": "Path 5131",
    d: "M278.763,316.91a.7.7,0,0,0,1-.973l-4.011-4.146a.7.7,0,0,0-1,.973Z",
    transform: "translate(-106.467 -209.43)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.266955d00276dd5bedb2abe309f0b7c3.svg";
export { ForwardRef as ReactComponent };